module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editable-select-list",
    class: {
      'expanded': !_vm.compact
    },
    attrs: {
      "data-object-type": _vm.selectedObjectType
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "control-group"
  }, [(_vm.objectTypes.length > 1) ? _c('PrettySelect', {
    attrs: {
      "options": _vm.objectTypes,
      "value": _vm.selectedObjectType
    },
    on: {
      "change": function (val) { return _vm.$emit('selectObjectType', val); }
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.objectTypes[0].display || _vm.objectTypes[0].displayName))]), _vm._v(" "), (_vm.addRow) ? _c('a', {
    staticClass: "add-new",
    attrs: {
      "title": "Create new"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('AddNew', {
    staticClass: "button"
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "control-group"
  }, [_c('a', {
    attrs: {
      "title": _vm.compact ? 'expand' : 'contract'
    },
    on: {
      "click": _vm.toggleCompact
    }
  }, [_c('DoubleArrows', {
    staticClass: "button",
    attrs: {
      "transform": _vm.compact ? '' : 'scale(-1, 1)'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "input-text search-spot"
  }, [(_vm.searchAvailable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "search-bar",
    attrs: {
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.compact) ? _c('LibrarySelect', {
    attrs: {
      "rows": _vm.searchedRows,
      "selectItem": _vm.selectRow,
      "destroyItem": _vm.destroyRow,
      "selectedItemId": _vm.selectedRowId,
      "duplicateRow": _vm.duplicateRow
    }
  }) : _c('EditableTable', {
    attrs: {
      "selectRow": _vm.selectRow,
      "selectedItemId": _vm.selectedRowId,
      "columns": _vm.visibleColumns,
      "rows": _vm.searchedRows,
      "deleteRow": _vm.destroyRow,
      "updateRow": _vm.editRow,
      "duplicateRow": _vm.duplicateRow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-746cecc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditableSelectList.vue
// module id = 755
// module chunks = 2